// extracted by mini-css-extract-plugin
export default {"languageIcon":"styles_languageIcon__Vwjoz"};